var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Hallway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 55v4H34L9 68.8V19.38L31.23 11H61v44h5zm-9 0v-6.94L36.08 55H57zm-26 1V15.75l-18 7.12V63l18-7zM20.29 39.73l-2.85 1a2 2 0 101.28 3.79l2.84-1a2 2 0 00-1.27-3.79z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Hallway.171a7e01.svg";
export { SvgE4Hallway as ReactComponent };